// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"0":"3c7ba95e","45":"56ffa57f","111":"bdd778f9","158":"38e0f758","252":"361e7307","375":"afd62ac6","502":"c5dde8c0","506":"557b0942","539":"b84550c4","701":"5e327a40","776":"f4e1b057"}[chunkId] + ".chunk.js";
};